<script setup lang="ts">
type Props = {
  title?: string;
};

const { title } = defineProps<Props>();
</script>

<template>
  <div :class="$style.userPageBox">
    <div
      v-if="title"
      :class="$style.boxTitle"
    >
      {{ title }}
    </div>

    <slot />
  </div>
</template>

<style module lang="postcss">
.userPageBox {
  @apply bg-bg-secondary rounded-md text-texts p-4 md:p-6 relative;

  border-radius: 10px;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  gap: 30px;
  padding: 30px;

  .boxTitle {
    @apply mb-5 text-primary font-bold text-base xl:text-lg border-b border-solid border-texts/10 w-full pb-1 -mt-1;
  }
}
</style>
